<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div v-if="!nearest" class="dw-subsm-empty">
            <div class="dw-subsm-empty-icon"><i class="bi bi-shield-exclamation"></i></div>
            <div class="dw-subsm-empty-text">{{ $t('common.dashboard.widgetEmpty.subscriptionSummaryTitle') }}</div>
            <div class="dw-subsm-empty-sub">{{ $t('common.dashboard.widgetEmpty.subscriptionSummarySub') }}</div>
        </div>
        <div v-else class="dw-astats-body dw-astats-body--compact">
            <div class="dw-astats-hero">
                <span v-if="nearest.expires_at" class="dw-astats-hero-num" :style="{ color: statusMap[nearest.status.class]?.color }">{{ $t('common.dashboard.widgetLabels.subsRemainingDaysShort', { days: nearest.remaining_days }) }}</span>
                <span v-else class="dw-astats-hero-num" :style="{ color: statusMap[nearest.status.class]?.color }">{{ $t('common.dashboard.widgetLabels.subsUnlimited') }}</span>
                <span class="dw-astats-hero-lbl">{{ nearest.product_name }}</span>
            </div>
            <div v-if="nearest.expires_at" class="dw-astats-bar-section">
                <div class="dw-astats-bar dw-storage-simple-bar-track">
                    <div class="dw-storage-simple-bar-fill" :style="{ width: progress(nearest) + '%', background: statusMap[nearest.status.class]?.color }"></div>
                </div>
            </div>
            <div class="dw-subsm-footer">
                <div class="dw-subsm-footer-item">
                    <span class="dw-subsm-footer-lbl">{{ $t('common.dashboard.widgetLabels.subsStatus') }}</span>
                    <span class="dw-subs-chip" :style="{ color: statusMap[nearest.status.class]?.color, background: statusMap[nearest.status.class]?.bg }">
                        {{ nearest.status.label }}
                    </span>
                </div>
                <div class="dw-subsm-footer-sep"></div>
                <div class="dw-subsm-footer-item">
                    <span class="dw-subsm-footer-lbl">{{ $t('common.dashboard.widgetLabels.subsExpiry') }}</span>
                    <span class="dw-subsm-footer-val">{{ nearest.expires_at ? formatDate(nearest.expires_at) : '—' }}</span>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';
import { formatSubDate, subscriptionProgress, STATUS_MAP } from './_subscriptionUtils';

export const meta = {
    id: 'subscription_summary',
    titleKey: 'common.dashboard.widgetTitles.subscription_summary',
    icon: 'bi-shield-exclamation',
    accent: 'var(--bs-warning)',
    accentBg: 'rgba(var(--bs-warning-rgb, 255, 199, 0), 0.12)',
    glassRgb: '255, 199, 0',
    defaultCol: 1,
    defaultRow: 1,
    source: { type: 'statistics', key: 'subscriptions' },
};

export default {
    name: 'SubscriptionSummaryWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return {
            meta,
            statusMap: STATUS_MAP,
        };
    },
    computed: {
        items() {
            return Array.isArray(this.apiData) ? this.apiData : [];
        },
        nearest() {
            const expiring = this.items.filter(s =>
                (s.status?.class === 'active' || s.status?.class === 'suspended') && s.expires_at,
            );
            if (expiring.length) {
                return expiring.reduce((a, b) => (a.remaining_days ?? Infinity) <= (b.remaining_days ?? Infinity) ? a : b);
            }
            const active = this.items.find(s => s.status?.class === 'active' || s.status?.class === 'suspended');
            return active || this.items[0] || null;
        },
    },
    methods: {
        formatDate: formatSubDate,
        progress: subscriptionProgress,
    },
};
</script>

<style>
.dw-subsm-empty {
    flex: 1;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center;
    gap: 8px; text-align: center;
    padding: 8px 12px;
}
.dw-subsm-empty-icon {
    width: 56px; height: 56px;
    border-radius: 16px;
    display: flex; align-items: center; justify-content: center;
    background: rgba(var(--bs-warning-rgb, 255, 199, 0), 0.10);
    color: var(--bs-warning);
    margin-bottom: 4px;
}
.dw-subsm-empty-icon .bi { font-size: 26px; }
.dw-subsm-empty-text {
    font-size: 13px; font-weight: 600;
    color: var(--bs-body-color);
}
.dw-subsm-empty-sub {
    font-size: 11px; color: var(--bs-gray-500);
    line-height: 1.4; max-width: 220px;
}
</style>
